// import { Flickity } from 'flickity'
import Flickity from 'flickity'

export default class Carousel {
  constructor(el) {
    this.el = el
    this.setVariables()
    this.init()
  }

  setVariables() {
    // this.next = this.el.querySelector('[data-next]')
    // this.prev = this.el.querySelector('[data-prev]')
    this.prevNextButtons = this.el.dataset.showprevnext ? this.el.dataset.showprevnext : true;
    this.groupCells = this.el.dataset.groupcells ? this.el.dataset.groupcells : false;
    this.hiddenCls = 'hidden';
    this.slides = this.el.querySelectorAll('.carousel-cell');
  }

  init() {
    this.handleRemoveHidden()
    this.initCarousel()
  }

  handleRemoveHidden() {
    this.slides.forEach( element => {
      element.classList.remove(this.hiddenCls);
    } )
  }

  initCarousel() {
    let showButtons = (this.prevNextButtons === "true" || this.prevNextButtons == true);
    let groupCells = (this.groupCells === "true" || this.groupCells == true);
    console.log(showButtons);
    const flkty = new Flickity(this.el, {
      arrowShape:
        'M75.16,46.12H38l18-18a3.87,3.87,0,1,0-5.46-5.5L26,47.28a3.84,3.84,0,0,0,0,5.45L50.62,77.39a3.9,3.9,0,1,0,5.46-5.57l-18-18H75.16Z',
      accessibility: true,
      adaptiveHeight: false,
      autoPlay: 5000,
      cellAlign: 'center',
      cellSelector: '.carousel-cell',
      contain: true,
      draggable: '>1',
      dragThreshold: 3,
      freeScroll: false,
      friction: 0.2,
      groupCells: groupCells,
      initialIndex: 0,
      lazyLoad: true,
      percentPosition: true,
      prevNextButtons: showButtons, // we're manually adding these
      pageDots: false,
      resize: true,
      rightToLeft: false,
      setGallerySize: true,
      watchCSS: true,
      // watches the content of :after of the element
      // activates if #element:after { content: 'flickity' }
      wrapAround: true
    })

    // manually advance or select last slide
    if(this.next) {
      this.next.addEventListener('click', () => {
        flkty.next(true)
      })
    }
    if(this.prev) {
      this.prev.addEventListener('click', () => {
        flkty.previous(true)
      })
    }
  }
}
